export const studentFields = [
    {
        section: "Basic Information",
        fields: [
            { name: "firstName", label: "First Name", required: true, type: "text" },
            { name: "middleName", label: "Middle Name", type: "text" },
            { name: "lastName", label: "Last Name", required: true, type: "text" },
            { name: "gender", label: "Gender", required: true, type: "select", options: ["MALE", "FEMALE", "OTHER"] },
            { name: "dob", label: "Date of Birth", required: true, type: "date" },
            { name: "bloodGroup", label: "Blood Group", type: "select", options: ["A_POSITIVE", "A_NEGATIVE", "B_POSITIVE", "B_NEGATIVE", "O_POSITIVE", "O_NEGATIVE", "AB_POSITIVE", "AB_NEGATIVE"] },
            { name: "nationality", label: "Nationality", type: "text" },
            { name: "religion", label: "Religion", type: "text" },
            { name: "rollNumber", label: "Roll Number", type: "text" },
            { name: "admissionId", label: "Admission Number", required: true, type: "text" },
            { name: "admissionDate", label: "Admission Date", type: "date" },
        ]
    },
    {
        section: "Contact Information",
        fields: [
            { name: "currentAddress", label: "Address", required: true, type: "text" },
            { name: "currentAddress2", label: "Address Line 2", type: "text" },
            { name: "city", label: "City", required: true, type: "text" },
            { name: "state", label: "State", type: "text" },
            { name: "pincode", label: "Pincode", type: "text" },
            { name: "email", label: "Email", required: true, type: "email" },
            { name: "phoneNumber", label: "Contact Number", required: true, type: "text", maxLength: 10 },
            { name: "alternatePhoneNumber", label: "Alternate Contact Number", type: "text", maxLength: 10 },
            { name: "lastFourDigitsOfAadhaarNumber", label: "Last Four Digits of Aadhaar", type: "text", maxLength: 4 },
        ]
    },
    {
        section: "Parent/Guardian Details",
        fields: [
            { name: "fatherName", label: "Father's Name", type: "text" },
            { name: "fatherOccupation", label: "Father's Occupation", type: "text" },
            { name: "fatherContact", label: "Contact Number (Father)", type: "text", maxLength: 10 },
            { name: "fatherEmail", label: "Father's Email", type: "email" },
            { name: "motherName", label: "Mother's Name", type: "text" },
            { name: "motherOccupation", label: "Mother's Occupation", type: "text" },
            { name: "motherContact", label: "Contact Number (Mother)", type: "text", maxLength: 10 },
            { name: "motherEmail", label: "Mother's Email", type: "email" },
        ]
    },
    {
        section: "Other Details",
        fields: [
            { name: "previousSchoolDetails", label: "Previous School Details", type: "text" },
            { name: "scholarshipAwards", label: "Scholarship Awards", type: "text" },
            { name: "transportOpted", label: "Transport Opted", type: "checkbox" },
        ]
    }
];
